import React from 'react';
import Header from './components/Header';
import Form from './components/Form';

const ResetPassword: React.FC = () => {
  return (
    <div className="w-px-400 mx-auto">
      <Header />
      <Form />
    </div>
  );
};

export default ResetPassword;
